import { render, staticRenderFns } from "./TranslateEarth.vue?vue&type=template&id=299edf1e&scoped=true"
import script from "./TranslateEarth.vue?vue&type=script&lang=js"
export * from "./TranslateEarth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299edf1e",
  null
  
)

export default component.exports